import React from 'react';
import styled from 'styled-components';
import Img_ from 'gatsby-image';
import { breakpoints } from '../constants';

const NameCell = styled.td`
    vertical-align: middle !important;
`;

const StandCell = NameCell;

const LogoCell = styled.td`
    text-align: center;
    vertical-align: middle !important;
    // img {
    //     max-width: 200px;
    //     max-height: 100px;
    //     padding: 10px;
    // }
`;

const Img = styled(Img_)`
    width: 200px;
    max-height: 100px;
    margin: 5px;
    @media (max-width: ${breakpoints.mobile}) {
        width: 100px;
    }
`;

export default ({ exhibitors, logos }) => (
    <table className="table">
        <tbody>
            {exhibitors
                .sort((a, b) => (a.node.name > b.node.name ? 1 : -1))
                .map(({ node }) => {
                    const sizes = getLogoSizes(node.code, logos);
                    return (
                        <tr key={node.id}>
                            <NameCell>
                                <a
                                    href={extractWebsite(node.website)}
                                    target="__blank"
                                >
                                    {node.name}
                                </a>
                            </NameCell>
                            <LogoCell>
                                {sizes && (
                                    <Img
                                        sizes={sizes}
                                        imgStyle={{
                                            objectFit: 'contain',
                                        }}
                                    />
                                )}
                            </LogoCell>
                            <StandCell>{node.stand}</StandCell>
                        </tr>
                    );
                })}
        </tbody>
    </table>
);

const getLogoSizes = (code, logos) => {
    const logo = logos.find(({ node }) => node.name === code);
    return logo && logo.node.childImageSharp.sizes;
};

const extractWebsite = (str) => {
    if (!str) {
        return 'javascript:;';
    }
    const url = (str && str.split(/[\s,;]/)[0]) || '';
    return url.substr(0, 4) === 'http' ? url : `http://${url}`;
};

export const query = graphql`
    fragment Exhibitors on RootQueryType {
        exhibitors: allExhibitor {
            edges {
                node {
                    id
                    code
                    name
                    website
                    stand
                }
            }
        }
        exhibitorsImages: allFile(
            filter: { sourceInstanceName: { eq: "exhibitors" } }
        ) {
            edges {
                node {
                    name
                    childImageSharp {
                        sizes(maxWidth: 200) {
                            ...GatsbyImageSharpSizes
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/ExhibitorsList.js